import axios from 'axios';
import Config from '../../config-app/config'
import Constants from "./constants";
import * as ResponseTransformers from "./responseTransformers";


export const getMainStatus = async () => {
  try {
    const response = await axios.get(Config.CDN_API_ENDPOINT + "/mainStatus.php");
    const data = handleResponse(response);
    return ResponseTransformers.msCalciatori(data);
  } catch (error) {
    console.error('Status calciatore (cerchio a destra del calciatore) non disponibile al momento.', error.message);
  }
};

export const getListoneConf = async () => {
  const response = await axios.get(Config.API_ENDPOINT + "/get_listone_conf.php");
  const data = handleResponse(response);
  return ResponseTransformers.listoneConf(data);
};

export const getTipiMercatiLega = async (ID_Lega) => {
  const response = await axios.get(Config.API_ENDPOINT + "/get_tipi_mercati_lega.php", {
    params: {
      ID_Lega
    },
  });
  const data = handleResponse(response);
  return ResponseTransformers.tipiMercatiLega(data);
};

export const getUserPublicInfo = async (uid) => {
  const response = await axios.get(Config.API_ENDPOINT + "/get_user_public_info.php", {
    params: {
      uid
    },
  });
  const data = handleResponse(response);
  return data.user;
};

export const saveStatoMercato = async ({
  uid,
  sessid,
  os,
  ID_Lega,
  ID_Divisione,
  tipoMercato,
  statoMercato,
}) => {

  const response = await axios.post(
    Config.API_ENDPOINT + "/save_statoMercato.php",
    JSON.stringify({
      ID_Lega,
      ID_Divisione,
      tipoMercato,
      statoMercato,
    }),
    {
      params: {
        uid,
        sessid
      },
      withCredentials: true,
    }
  );
  return handleResponse(response);
};

const handleResponse = (response) => {
  if (response.status === 200) {
    if (response.data.status == 1) {
      return response.data.data
    } else {
      throw new Error(`${response.data.msg}`);
    }
  } else {
    throw new Error(`Unexpected status code: ${response.status}`);
  }
};

// api mixins
// import toast from "./toast";
// export default {
//   mixins: [toast],
//   methods: {
//     async getMainStatus() {
//       try {
//         const response = await axios.get(Config.CDN_API_ENDPOINT + "/mainStatus.php");
//         const data = handleResponse(response);
//         return ResponseTransformers.msCalciatori(data);
//       } catch (error) {
//         this.errorToast('Pallino status calciatore non disponibile al momento', error.message);
//       }
//     },

//     handleResponse(response) {
//       if (response.status !== 200) {
//         if (response.data.status == 1) {
//           return response.data.data
//         } else {
//           console.error('error', response.data.msg);
//         }
//       } else {
//         throw new Error(`Unexpected status code: ${response.status}`);
//       }
//     }
//   }
// }
